"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.sort");
require("core-js/modules/es6.function.name");
var _ObjectForm = _interopRequireDefault(require("@/components/ObjectForm"));
var _nav = require("@/api/nav/nav");
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    formIcon: _ObjectForm.default
  },
  data: function data() {
    return {
      formData: {
        rules: {
          name: [{
            required: true,
            message: "请输入导航名称",
            trigger: "blur"
          }, {
            min: 1,
            max: 10,
            message: "导航名称建议1到10个字",
            trigger: "blur"
          }],
          linkUrl: [{
            required: true,
            message: "请输入导航路径",
            trigger: "blur"
          }, {
            min: 1,
            max: 300,
            message: "长度请在1到300个字符之间",
            trigger: "blur"
          }],
          sort: [{
            required: true,
            message: "请输入排序位置",
            trigger: "blur"
          }, {
            min: 1,
            max: 3,
            message: "长度请在1到3个字符之间",
            trigger: "blur"
          }]
        },
        labelWidth: "120px",
        inline: false,
        labelPosition: "right",
        size: "small",
        formItem: [{
          type: "input",
          label: "导航名称：",
          isDisabled: false,
          placeholder: "请输入导航名称",
          prop: "name",
          value: ""
        }, {
          type: "input",
          label: "导航路径：",
          isDisabled: false,
          placeholder: "请输入导航路径",
          prop: "linkUrl",
          value: ""
        }, {
          type: "input",
          label: "排序位置：",
          isDisabled: false,
          placeholder: "请输入排序位置",
          prop: "sort",
          value: ""
        }]
      }
    };
  },
  methods: {
    submit: function submit(e) {
      var _this = this;
      console.log(e);
      (0, _nav.navEdit)({
        id: this.$route.query.id,
        linkUrl: e.linkUrl,
        name: e.name,
        sort: e.sort
      }).then(function (res) {
        _this.$router.push("/webSet/webSetNav");
        _this.$message.success("操作成功。");
      });
    }
  },
  created: function created() {
    var formItem = this.formData.formItem;
    formItem[0].value = this.$route.query.name;
    formItem[1].value = this.$route.query.linkUrl;
    formItem[2].value = this.$route.query.sort;
  }
};